const isOnSale = (product) => {
  if (!product) return false
  return product.special_price && product.special_price > 0
}

export default isOnSale